import { getPlan } from "@/Services/TherapyApi/Plans";

import PlanTransformer from "@/Modules/Transformers/Plan";

import usePlanStore from "@/Modules/Plan/Store";

import { isObject } from "@/Utils/Objects";
import { log } from "@/Utils/Debug";

async function fetchCurrentPlanAH(planUuid: string) {
  const planStore = usePlanStore();

  planStore.loading = true;
  const plan = planStore.plans.find((plan) => plan.id === planUuid);

  // if the plan exist directly in the store not need to find in backend.
  if (isObject(plan)) {
    planStore.currentPlan = plan;
  } else {
    try {
      const planApiResponse = await getPlan(planUuid);

      planStore.currentPlan = PlanTransformer.toDomain(planApiResponse);
    } catch (error) {
      log("Error fetch current plan", error);
    } finally {
      planStore.loading = false;
    }
  }
}

export default fetchCurrentPlanAH;
